(async () => {

  if (!customElements.get('login-page')) {

    class LoginPage extends HTMLElement {
      constructor() {
        super();

        this.targetTrigger = document.querySelectorAll('[data-id-target-trigger]');

        this.targetTrigger?.forEach((trigger) => {
          trigger.addEventListener('click', (event) => {
            event.preventDefault();
            document.querySelector(trigger.getAttribute('href')).classList.remove('hidden');
            trigger.closest('[data-group-target]').classList.add('hidden');
          });
        });

      }

    }

    window.LoginPage = LoginPage;

    customElements.define('login-page', LoginPage);

  }

})();